import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  Dialog,
  IconButton,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import VideoGuideDialog from "./VideoGuideDialog";
import MicIcon from "@mui/icons-material/Mic";
import CloseIcon from "@mui/icons-material/Close";

import { useNavigate } from "react-router-dom";

import BlurryBackdrop from "./BlurryBackdrop";
import { VideoPlayer } from "./HelpDialogItems";
const DarkEmeraldPodcastBox = () => {
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const navigate = useNavigate();
  // Video details
  const videoUrl =
    "https://sportkuriren.se/wp-content/uploads/podcast-generera-2.mp4";
  const posterUrl =
    "https://sportkuriren.se/wp-content/uploads/podcast-generera.png";

  return (
    <Paper
      //onClick={() => setVideoDialogOpen(true)}
      elevation={5}
      sx={{
        position: "relative",
        width: "100%",
        height: "300px",
        borderRadius: "12px",
        backgroundColor: "#111827", // gray-900
        overflow: "hidden",
        boxShadow: "none",
        transition: "all 0.2s",
        cursor: "pointer",
        "&:hover": {
          transform: "scale(1.03)",
        },
      }}
    >
      {/* "Ny!" badge */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          backgroundColor: "#10b981", // emerald-500
          paddingX: "13px",
          paddingY: "5px",
          borderBottomRightRadius: "8px",
          zIndex: 10,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: "0.85rem",
            fontWeight: 600,
            color: "white",
          }}
        >
          NYHET!
        </Typography>
      </Box>
      {/* Content container */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "24px",
          color: "white",
        }}
      >
        {/* Title */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: "1.7rem",
            textAlign: "center",
            marginBottom: "18px",
            marginTop: "15px",
          }}
        >
          Generera din egen podcast med AI
        </Typography>

        {/* Divider line */}
        <Box
          sx={{
            width: "48px",
            height: "4px",
            backgroundColor: "#10b981", // emerald-500
            marginBottom: "15px",
          }}
        />

        {/* Description */}
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.89rem",
            color: "#d1d5db", // gray-300
            textAlign: "center",
            marginBottom: "24px",
            maxWidth: "85%",
          }}
        >
          Välj valfritt underlag. Stöd för 50 språk. Ladda ned eller dela.
        </Typography>

        {/* Play button */}
        <Button
          variant="purp"
          startIcon={<MicIcon />}
          sx={{
            display: { xs: "none", md: "inline-flex" },
            borderBottom: 0,
            background: "#12b981",
            width: "231px",
            fontWeight: 600,
            borderRadius: "8px",
            paddingTop: "9px",
            paddingBottom: "9px",
            fontSize: "0.97rem",
            height: "50px",
            overflow: "hidden",
            "& .MuiSvgIcon-root": {
              fontSize: "1.35rem",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: -50,
              left: -100,
              width: "70px",
              height: "200px",
              background: "rgba(255, 255, 255, 0.05)",
              transform: "rotate(10deg)",
              animation: "shimmerEffect 3s infinite",
              zIndex: 1,
              pointerEvents: "none",
            },
            "@keyframes shimmerEffect": {
              "0%": {
                transform: "translateX(-200px) rotate(10deg)",
              },
              "100%": {
                transform: "translateX(400px) rotate(10deg)",
              },
            },
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              zIndex: 0,
              overflow: "hidden",
            },
          }}
          //onClick={() => setLessonLimitDialogOpen(true)}
        >
          {/* Moving dots in background */}
          <span
            style={{
              position: "absolute",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              top: "20%",
              left: "15%",
              animation:
                "moveDot1 10s infinite linear, opacityChange1 7s infinite alternate",
              zIndex: 0,
            }}
          />
          <span
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              top: "60%",
              left: "40%",
              animation:
                "moveDot2 13s infinite linear, opacityChange2 8s infinite alternate",
              zIndex: 0,
            }}
          />
          <span
            style={{
              position: "absolute",
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.55)",
              top: "30%",
              left: "70%",
              animation:
                "moveDot3 15s infinite linear, opacityChange3 6s infinite alternate",
              zIndex: 0,
            }}
          />
          <span
            style={{
              position: "absolute",
              width: "4px",
              height: "4px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.45)",
              top: "75%",
              left: "85%",
              animation:
                "moveDot4 11s infinite linear, opacityChange4 9s infinite alternate",
              zIndex: 0,
            }}
          />
          <style jsx>{`
            @keyframes moveDot1 {
              0% {
                transform: translate(0, 0);
              }
              25% {
                transform: translate(10px, 15px);
              }
              50% {
                transform: translate(20px, 0);
              }
              75% {
                transform: translate(10px, -15px);
              }
              100% {
                transform: translate(0, 0);
              }
            }
            @keyframes moveDot2 {
              0% {
                transform: translate(0, 0);
              }
              33% {
                transform: translate(-15px, 10px);
              }
              66% {
                transform: translate(15px, 10px);
              }
              100% {
                transform: translate(0, 0);
              }
            }
            @keyframes moveDot3 {
              0% {
                transform: translate(0, 0);
              }
              25% {
                transform: translate(-10px, -10px);
              }
              50% {
                transform: translate(-15px, 5px);
              }
              75% {
                transform: translate(5px, 10px);
              }
              100% {
                transform: translate(0, 0);
              }
            }
            @keyframes moveDot4 {
              0% {
                transform: translate(0, 0);
              }
              25% {
                transform: translate(8px, -12px);
              }
              50% {
                transform: translate(-8px, -8px);
              }
              75% {
                transform: translate(-12px, 12px);
              }
              100% {
                transform: translate(0, 0);
              }
            }
            @keyframes opacityChange1 {
              0% {
                opacity: 0.2;
              }
              100% {
                opacity: 0.5;
              }
            }
            @keyframes opacityChange2 {
              0% {
                opacity: 0.3;
              }
              100% {
                opacity: 0.6;
              }
            }
            @keyframes opacityChange3 {
              0% {
                opacity: 0.15;
              }
              100% {
                opacity: 0.45;
              }
            }
            @keyframes opacityChange4 {
              0% {
                opacity: 0.25;
              }
              100% {
                opacity: 0.55;
              }
            }
          `}</style>
          <span style={{ position: "relative", zIndex: 2 }}>Prova nu!</span>
        </Button>
      </Box>
      {/* Video Dialog */}

      <Dialog
        open={videoDialogOpen}
        onClose={() => setVideoDialogOpen(false)}
        maxWidth="md"
        fullWidth
        disableEnforceFocus
        BackdropComponent={BlurryBackdrop}
        disableScrollLock
        disableRestoreFocus
        onClick={(e) => {
          e.stopPropagation();
          setVideoDialogOpen(false);
        }}
        PaperProps={{
          sx: { backgroundColor: "transparent", maxWidth: "700px" },
          onClick: (e) => e.stopPropagation(),
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            aria-label="close"
            onClick={() => setVideoDialogOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1,
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          <VideoPlayer
            videoUrl={videoUrl}
            poster={posterUrl}
            autoPlay
            controls
          />
          <Box
            sx={{
              textAlign: "center",
              p: 5,
              backgroundColor: "rgba(17, 24, 39, 0.95)",
            }}
          >
            <Button
              onClick={() => navigate("/app/podcast")}
              variant="purp"
              startIcon={<MicIcon />}
            >
              Generera podcast nu
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Paper>
  );
};

export default DarkEmeraldPodcastBox;
